module.exports = __webpack_public_path__ + "static/img/s_10.aa4b90aa.png";